import React from "react";
import { useSelector } from "react-redux";

const HtmlBigIcon = ({ fill }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43.947"
      height="52.737"
      viewBox="0 0 43.947 52.737"
    >
      <path
        id="db40"
        d="M228.819,164.544a4.756,4.756,0,0,0-3.99-1.653H201.92c-2.517,0-3.506.989-3.506,3.507v45.724c0,2.517.989,3.507,3.507,3.507h36.934c2.518,0,3.507-.989,3.507-3.507v-31.7a4.756,4.756,0,0,0-1.653-3.99Zm10.475,47.082c0,.671-.264.935-.935.935H202.415c-.671,0-.935-.264-.935-.935V200.283h37.814v11.343Zm-31.1-20.511v-4.053h2.191V197.61h-2.191V193.2h-3.62v4.413h-2.2V187.062h2.205v4.053Zm3.372-2.05v-2h7.468v2h-2.653v8.545h-2.206v-8.545Zm8.36,8.545.621-10.548h2.927l.952,3.521c.3,1.22.6,2.535.822,3.772h.043c.274-1.22.606-2.613.923-3.787l1.038-3.505h2.869l.533,10.548H228.5l-.144-4.038c-.043-1.267-.086-2.8-.086-4.334h-.044c-.3,1.346-.706,2.848-1.081,4.084l-1.182,4.115H224.25l-1.038-4.084c-.318-1.236-.649-2.739-.88-4.116H222.3c-.058,1.424-.1,3.052-.174,4.366l-.173,4.007Zm18.481-2v2h-6.069V187.062h2.205v8.545Zm.888-11.219H201.48v-17.5c0-.671.263-.935.935-.935h23.348c.335,0,.467.132.467.467v9.089c0,2.517.989,3.507,3.506,3.507h9.089c.336,0,.467.132.467.467Z"
        transform="translate(-198.414 -162.891)"
        fill={fill ? fill : colors.theme}
      />
    </svg>
  );
};

export default HtmlBigIcon;
